<page-load-header *ngIf="!initialized"></page-load-header>

<div>
  <div *ngIf="initialized" class="container">
    <div class="row mb-5">
      <div class="col-md-12">
        <form class="form" [formGroup]="formGroup" novalidate>
          <div class="row mb-3">
            <div class="col-sm-6 pull-right">
              <h3>Exhibit Designer</h3>
            </div>
            <div class="col-sm-6 text-right pull-right">
              <button class="btn btn-outline-dark mr-1" (click)="cancel()" type="button">Cancel</button>

              <button class="btn btn-secondary mr-1" [promiseBtn]="submitComplete" type="button" (click)="onSave(true)">Save & Preview</button>
              <button class="btn btn-primary" [promiseBtn]="submitComplete" type="button" (click)="onSave(false)">Save</button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-5">
              <div class="row mb-2">
                <div class="col-md-12">
                  <label for="firstName">Exhibit Logo (380x360) displayed in the "virtual exhibit hall"</label>
                  <div class="media align-items-center mb-2">
                    <div class="u-lg-avatar mr-3">
                      <span *ngIf="!logoCroppedImage && !exhibit.logoAssetPath" class="btn btn-lg btn-icon btn-dark rounded-circle mr-3">
                        <span class="btn-icon__inner">AC</span>
                      </span>
                      <img *ngIf="exhibit.logoAssetPath && !logoCroppedImage" class="img-fluid" style="max-height: 200px" src="fetchImage?filename={{ exhibit.logoAssetPath }}"  />
                      <img *ngIf="logoCroppedImage" class="img-fluid" style="max-height: 200px" [src]="logoCroppedImage"  />
                    </div>

                    <div class="media-body">
                      <button type="button" (click)="editLogoImage(logoContent)" class="btn btn-sm btn-primary transition-3d-hover mb-1 mr-2 mb-sm-0">Upload New Logo</button>
                      <button type="button" class="btn btn-sm btn-soft-secondary transition-3d-hover mb-1 mb-sm-0">Delete</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <label for="firstName">Exhibit Name</label>
                  <input type="text" class="form-control" formControlName="title" />
                  <div class="invalid-message">
                    <div>Name is required</div>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <label for="firstName">Exhibit Subtitle</label>
                  <input type="text" class="form-control" formControlName="subtitle" />
                  <div class="invalid-message">
                    <div>Name is required</div>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <label for="firstName">Conference</label>
                  <input type="text" class="form-control" readOnly formControlName="conferenceName" />
                  <div class="invalid-message">
                    <div>Name is required</div>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <label for="firstName">Website</label>
                  <input type="text" class="form-control" formControlName="website" />
                  <div class="invalid-message">
                    <div>Website is required</div>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <label for="firstName">Welcome Video <span class="text-muted">Paste a link to an internet video (youtube, vimeo, etc)</span></label>
                  <input type="text" class="form-control" formControlName="introVideoAssetPath" />
                  <div class="invalid-message">
                    <div>Title is required</div>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <label for="firstName">Visibility</label>
                  <select class="form-control" formControlName="published">
                    <option [value]="true">Published</option>
                    <option [value]="false">Draft</option>
                  </select>
                  <div class="invalid-message">
                    <div>Published is required</div>
                  </div>
                </div>
              </div>
              <!-- <div class="row">
                <div class="col-md-12">
                  <label for="firstName">Additional Presenters (Comma separated emails)</label>
                  <input type="text" class="form-control" formControlName="additionalPresenters" />
                  <div class="invalid-message">
                    <div>First Name is required</div>
                  </div>
                </div>
              </div> -->
            </div>
            <div class="col-md-6 text-center">
              <img *ngIf="exhibit.bannerAssetPath && !bannerCroppedImage" class="img-fluid" style="max-height: 400px" src="fetchImage?filename={{ exhibit.bannerAssetPath }}"  />
              <img *ngIf="bannerCroppedImage" class="img-fluid" style="max-height: 600px" [src]="bannerCroppedImage"  />
              <img *ngIf="!bannerCroppedImage && !exhibit.bannerAssetPath" class="img-fluid" src="../../../assets/banner-placeholder.png" />

              <div class="row mt-3">
                <div class="col">
                  <label class="d-block">Please upload a jpg or png file of your banner at least 1000px X 100px</label>
                  <button type="button" (click)="editBannerImage(bannerContent)" class="btn btn-sm btn-primary transition-3d-hover mb-1 mr-2 mb-sm-0">Upload Banner</button>
                  <!-- <button type="button" class="btn btn-sm btn-soft-secondary transition-3d-hover mb-1 mb-sm-0">Delete</button> -->
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <label for="zip">Summary</label>
              <kendo-editor style="height: 650px" formControlName="description">
                <kendo-toolbar>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                  <kendo-toolbar-colorpicker kendoEditorBackColor></kendo-toolbar-colorpicker>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
                </kendo-toolbar>
              </kendo-editor>
              <div class="invalid-message">
                <div>Company Description is required</div>
              </div>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col">
              <h4>Materials</h4>
            </div>
            <div class="col text-right">
              <button type="button" class="btn btn-primary" (click)="addMaterial()">Add Material(s)</button>
            </div>
          </div>

          <div formArrayName="materials" *ngFor="let benefit of formGroup.controls.materials['controls']; let i = index">
            <div [formGroupName]="i" class="row">
              <div class="col-md-3 mb-3">
                <label for="firstName">Description</label>
                <i class="fa fa-asterisk"></i>
                <input type="text" class="form-control" formControlName="description" />
                <div class="invalid-message">
                  <div>Description is required</div>
                </div>
              </div>
              <div class="col-md-3 mb-3">
                <label for="country">File Type</label>
                <i class="fa fa-asterisk"></i>
                <select class="form-control" formControlName="fileType">
                  <option value="">Please Choose...</option>
                  <option *ngFor="let item of FileTypeEnum | keyvalue" value="{{ item.key }}">{{ item.value }}</option>
                </select>
                <div class="invalid-message">
                  <div>File Type is required</div>
                </div>
              </div>
              <div id="exhibitUpload" class="col-md-4 mb-3">
                <label for="country">File</label>
                <i class="fa fa-asterisk"></i>

                <kendo-upload *ngIf="!benefit.controls.fileName?.value" [saveUrl]="uploadUrl" [multiple]="false" (success)="successEventHandler($event, i)"></kendo-upload>
                <input type="text" *ngIf="benefit.controls.fileName?.value" class="form-control" [disabled]="true" readonly formControlName="fileName" />
                <div class="invalid-message">
                  <div>File is required</div>
                </div>
              </div>

              <div class="col-md-2">
                <label for="country">&nbsp;</label>
                <button type="button" class="d-block btn btn-icon btn-danger transition-3d-hover" (click)="removeMaterial(i)">
                  <span class="fas fa-trash btn-icon__inner"></span>
                </button>
              </div>
            </div>
          </div>
          <!-- <div class="row mt-2">

            <div class="col-md-12">
              <table class="table table-hover ">
                <thead class="bg-light ">
                  <tr>
                    <th>Description</th>
                    <th>Type</th>
                    <th class="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let material of exhibit.exhibitMaterials">
                    <td>
                      <a [routerLink]="['.', material.id, 'edit']">{{ material.description }}</a>
                    </td>
                    <td>{{ material.fileType }}</td>

                    <td class="text-right">
                      Edit | Delete
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> -->

          <!-- End My Network -->
        </form>
      </div>
    </div>

    <ng-template #bannerContent let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Edit Image</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="col-md-12 text-center">
          <label class="btn-bs-file btn btn-lg btn-primary">
            Choose an Image
            <input type="file" (change)="bannerFileChangeEvent($event)" />
          </label>

          <image-cropper [imageChangedEvent]="bannerImageChangedEvent" [imageBase64]="bannerInitialCroppedImage" [maintainAspectRatio]="false" [onlyScaleDown]="true" format="png" (imageCropped)="bannerImageCropped($event)" (imageLoaded)="bannerImageLoaded()" (loadImageFailed)="bannerLoadImageFailed()"></image-cropper>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button>
      </div>
    </ng-template>

    <ng-template #logoContent let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Edit Logo</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="col-md-12 text-center">
          <label class="btn-bs-file btn btn-lg btn-primary">
            Choose a Logo Image
            <input type="file" (change)="logoFileChangeEvent($event)" />
          </label>

          <image-cropper [imageChangedEvent]="logoImageChangedEvent" [imageBase64]="logoInitialCroppedImage" [maintainAspectRatio]="false" [onlyScaleDown]="true" format="png" (imageCropped)="logoImageCropped($event)" (imageLoaded)="logoImageLoaded()" (loadImageFailed)="logoLoadImageFailed()"></image-cropper>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button>
      </div>
    </ng-template>
  </div>
</div>
